export default {
  setupDate: { id: 'apply' },
  cancel: { id: 'cancel' },
  day_1: { id: 'label_days_1' },
  days_3: { id: 'label_days_3' },
  week_1: { id: 'label_week_1' },
  weeks_2: { id: 'label_weeks_2' },
  month_1: { id: 'label_months_1' },
  allSelected: { id: 'all_selected' },
  listLimitMessage: { id: 'list_limit_message' },
}
